<!--
 ** @Author: guanxiaoyan guanxiaoyan@bjca.org.cn
 ** @Deion:
 ** @Date: 2022-09-16 17:13:35
 * @LastEditors: guanxiaoyan guanxiaoyan@bjca.org.cn
 * @LastEditTime: 2022-10-21 11:39:53
 * @FilePath: /ywx-open/vue/src/views/agent/serviceDetails/orderManage/components/patient.vue
-->
<template>
  <div>
    <div class="search-box">
      <MyForm class="search-form" :form="formData.form" :inline="true"
        :options="formData.options" />
      <div class="btns">
        <el-button type="primary" icon="el-icon-search" @click="searchForm()">搜索</el-button>
        <el-button type="primary" icon="el-icon-download" @click="exportData()">导出</el-button>
      </div>
    </div>
    <div>
      <MyTable :tableData="tableData" :headerColumns.sync="HeaderColumns" :hasPagination="true"
        :page="page" @page-change="(pagenum)=>{page.pageNum=pagenum;getTableList()}"
        @size-change="(size)=>{page.pageSize=size;getTableList()}" :operation="true"
        :operationWidth="260">
        <template slot="status" slot-scope="scope">
          <span :style="{color:signStatusTag(scope.row.status)}">
            {{scope.row.status}}</span>
        </template>
        <template slot="signStatus" slot-scope="scope">
          <span :style="{color:signStatusTag(scope.row.signStatus)}">
            {{paientSignStatusTypeBackEnum.getDescFromValue(scope.row.signStatus)}}</span>
        </template>
        <template slot="upDefault1" slot-scope="scope">
          <span>
            {{scope.row.upDefault1}}</span>
        </template>

        <template slot="menu" slot-scope="scope">
          <div class="flexrow">
            <el-button type="primary" size="small" @click="customerDetail(scope.row)">查看详情
            </el-button>
            <el-button
              v-if="scope.row.signStatus === paientSignStatusTypeEnum.Signed || scope.row.signStatus === 4"
              type="warning" size="small" @click="msgRepeatSend(scope.row)">补偿通知
            </el-button>
          </div>
        </template>
      </MyTable>
    </div>
    <!-- 客户签名详情 -->
    <div>
      <el-dialog title="患者签名详情" :visible.sync="detailModal" width="65%">
        <div>
          <el-descriptions title="" :column="2">
            <el-descriptions-item label="文件名称">{{detail.fileName || '--'}}
            </el-descriptions-item>
            <el-descriptions-item label="患者姓名">{{detail.patientName || '--'}}
            </el-descriptions-item>
            <el-descriptions-item label="患者身份证">{{detail.patientIdNum || '--'}}
            </el-descriptions-item>
            <el-descriptions-item label="发起日期">
              {{detail.createTime || '--'}}
            </el-descriptions-item>
            <el-descriptions-item label="签署状态" :span="2">
              <!-- {{detail.signStatus}} -->
              <span
                :style="{fontWeight:'bolder',color:renderStatus(detail.signStatus)}">{{paientSignStatusTypeBackEnum.getDescFromValue(detail.signStatus)}}</span>
            </el-descriptions-item>
            <el-descriptions-item label="签署日期">
              {{detail.signTime || '--'}}
            </el-descriptions-item>
            <el-descriptions-item label="医生姓名">
              {{detail.doctorName || '--'}}
            </el-descriptions-item>
            <el-descriptions-item label="签名原文" :span="2" contentClassName="flex1">
              <iframe title="sign" :src="detail.afterFile" scrolling="auto"
                :style="{ width: '100%', border: '0px', height: '600px',border:'1px solid #ccc' }" />
            </el-descriptions-item>

          </el-descriptions>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="detailModal = false">关 闭</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
  <script>
import { bus } from '@/utils/bus';
import MyForm from '@/components/form/index'
import MyTable from '@/components/myTableComponent/index'
import {
  formatObj,
  createEnum,
  isCallBackStatusType,
  paientSignStatusType,
  paientSignStatusTypeBack,
  formatArrOptions,
} from '@/utils/public'
import tagColor from '@/utils/color'
import { getFirmListByAgent } from '@/utils/pubilcFun'
import moment from 'moment'

// form表单 签名状态 下拉
const paientSignStatusTypeEnum = createEnum(paientSignStatusType)
const signStatusTypeOptions = formatObj(paientSignStatusTypeEnum.numToDescMap)
signStatusTypeOptions.unshift({ value: '', label: '全部' })
// 是否回调
const isCallBackStatusTypeOptions = formatObj(isCallBackStatusType)
isCallBackStatusTypeOptions.unshift({ value: 'ALL', label: '全部' })
// 表格--签署状态回显
const paientSignStatusTypeBackEnum = createEnum(paientSignStatusTypeBack)
// 医生签名表头
const HeaderColumns = [
  {
    title: '签名数据编号',
    dataIndex: 'uniqueid',
  },
  {
    title: '客户名称',
    dataIndex: 'clientName',
  },
  {
    title: '文件名称',
    dataIndex: 'fileName',
  },
  {
    title: '患者姓名',
    dataIndex: 'patientName',
  },
  {
    title: '医师姓名',
    dataIndex: 'doctorName',
  },
  {
    title: '患者身份证号',
    dataIndex: 'patientIdNum',
  },
  {
    title: '发起日期',
    dataIndex: 'createTime',
  },
  {
    title: '签署状态',
    dataIndex: 'signStatus',
    slot: true,
    width: '150px',
  },
]
export default {
  name: 'trustedUser',
  components: {
    MyForm,
    MyTable,
  },
  data() {
    return {
      paientSignStatusTypeBackEnum,
      isCallBackStatusTypeOptions,
      paientSignStatusTypeEnum,
      HeaderColumns,
      firmList: [],
      formData: {
        form: {
          createDate: '',
          clientId: '',
          uniqueid: '',
          likeCron: '',
          signStatus: '',
          dateValue: '',
        },
        options: [
          {
            title: '创建时间',
            key: 'dateValue',
            // type: 'date-to-date',
            // className: 'width250',
            type: 'datetime-to-datetime',
            className: 'width400',
          },
          {
            title: '客户名称',
            key: 'clientId',
            type: 'select',
            option: {
              data: this.firmList,
            },
            filterable: true,
            clearable: true,
            className: 'width300',
          },
          {
            title: '唯一标识',
            key: 'uniqueid',
            type: 'text',
          },
          {
            title: '签名状态',
            key: 'signStatus',
            type: 'select',
            option: {
              data: signStatusTypeOptions,
            },
            clearable: true,
          },
          {
            title: '关键字搜索',
            key: 'likeCron',
            type: 'text',
            placeholder: '输入患者姓名/身份证号搜索',
            className: 'width250',
          },
        ],
      },
      dateValue: '',
      tableData: [],
      page: {
        total: 0,
        pageNum: 1,
        pageSize: 10,
      },
      detailModal: false,
      detail: {},
      exportCheckSearch: false, // 导出之前先判断是否搜素
    }
  },
  created() {
    this.getClientIdList()
  },
  mounted() {
    // this.getTableList()
    bus.$on('tabChange', ()=>{
      console.log('点击了')
      this.exportCheckSearch = false;
    })
  },
  methods: {
    getClientIdList() {
      getFirmListByAgent().then((res) => {
        this.firmList = formatArrOptions(res, 'firmName', 'clientId')
        this.firmList.unshift({ value: '', label: '全部' })
        this.formData.options[1].option.data = this.firmList
        console.log('this.firmList', this.firmList)
      })
    },
      // 导出
    exportData() {

      if(!this.exportCheckSearch){
        this.$message.warning('请先搜索，在进行导出!')
        return
      }
      if(this.page.total > 10000){
        this.$message.warning('最大支持导出 1w 条数据，请缩小范围后重试!')
        return
      }

      const { dateValue, uniqueid, likeCron, clientId, signStatus } =
        this.formData.form;
        console.log(dateValue)
      if (!clientId) {
        this.$message.error('请选择一个导出客户!')
        return
      }
      const params = {
        startTime: dateValue ? moment(dateValue[0]).format('YYYY-MM-DD HH:mm:ss') : '',
        endTime: dateValue
          ? moment(dateValue[1]).format('YYYY-MM-DD HH:mm:ss')
          : '',
        uniqueid: uniqueid,
        likeCron: likeCron,
        clientId: clientId,
        signStatus: signStatus,
        // accountNo:'',//账号id
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
      }
      console.log(params)

      this.$API.exportPatientOrder(params).then((response) => {
        const blob = response
        const a = document.createElement('a')
        const url = window.URL.createObjectURL(blob)
        a.href = url
        // 设置文件名称
        a.download = `患者签名订单列表${moment().format(
          'YYYY-MM-DD'
        )}.xls`
        a.click()
      })
    },
    searchForm() {
      this.page.pageNum = 1
      this.getTableList()
    },
    getTableList() {
      const { dateValue, uniqueid, likeCron, clientId, signStatus } =
        this.formData.form
      if (!clientId) {
        this.$message.error('请选择一个查询客户!')
        return
      }
      const params = {
        startTime: dateValue ? moment(dateValue[0]).format('YYYY-MM-DD HH:mm:ss') : '',
        endTime: dateValue
          ? moment(dateValue[1]).format('YYYY-MM-DD HH:mm:ss')
          : '',
        uniqueid: uniqueid,
        likeCron: likeCron,
        clientId: clientId,
        signStatus: signStatus,
        // accountNo:'',//账号id
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
      }
      console.log(params)

      this.$API
        .patientSignListByAgent(params)
        .then((res) => {
          this.exportCheckSearch= true
          this.tableData = res.data.list
          this.page.total = res.data.total
        })
        .catch()
    },
    signStatusTag(signStatus) {
      let color = ''
      switch (signStatus) {
        case paientSignStatusTypeBackEnum.New:
          color = tagColor.purple
          break
        case paientSignStatusTypeBackEnum.Signing:
          color = tagColor.orange
          break
        case paientSignStatusTypeBackEnum.SignedNoBack:
        case paientSignStatusTypeBackEnum.SignedAndBack:
          color = tagColor.solidGreen
          break
        case paientSignStatusTypeBackEnum.Expired:
          color = tagColor.darkGray
          break
        case paientSignStatusTypeBackEnum.Deleted:
          color = tagColor.errorColor
          break
        case paientSignStatusTypeBackEnum.Abolished:
          color = tagColor.darkGray
          break
        default:
          color = tagColor.processingColor
          break
      }
      return color
    },
    // 表格--签署状态回显
    renderStatus(status) {
      let color = ''
      switch (Number(status)) {
        case paientSignStatusTypeBackEnum.New:
          color = tagColor.purple
          break
        case paientSignStatusTypeBackEnum.Signing:
          color = tagColor.orange
          break
        case paientSignStatusTypeBackEnum.SignedNoBack:
        case paientSignStatusTypeBackEnum.SignedAndBack:
          color = tagColor.solidGreen
          break
        case paientSignStatusTypeBackEnum.AwaitSigned:
        case paientSignStatusTypeBackEnum.PreSign:
          color = tagColor.processingColor
          break
        case paientSignStatusTypeBackEnum.Rejected:
        case paientSignStatusTypeBackEnum.Deleted:
        case paientSignStatusTypeBackEnum.RejectedAndBack:
          color = tagColor.errorColor
          break
        case paientSignStatusTypeBackEnum.Expired:
        case paientSignStatusTypeBackEnum.Abolished:
        case paientSignStatusTypeBackEnum.ExpiredAndBack:
        case paientSignStatusTypeBackEnum.AbolishedAndBack:
          color = tagColor.darkGray
          break
        case paientSignStatusTypeBackEnum.Unaccalimed:
        case paientSignStatusTypeBackEnum.Unsynthesized:
          color = tagColor.magenta
          break
        default:
          color = ''
      }
      return color
    },
    customerDetail(record) {
      console.log(record)
      const { uniqueid } = record
      this.detailModal = true
      this.$API
        .patientSignDetailByAgent({ uniqueid: uniqueid })
        .then((res) => {
          this.detail = res.data
        })
        .catch()
    },
    // 医师签名--补偿通知
    msgRepeatSend(record) {
      console.log(record)
      const { uniqueid, firmId } = record
      //分别对医师签名、客户签名进行补偿通知
      this.$API
        .patientMsgRepeatSendByAgent({ pdfSignId: uniqueid, clientId: firmId })
        .then(() => {
          this.$message.success('补偿通知发送成功')
        })
        .catch()
    },
  },
}
</script>
  <style lang="less" scoped>
</style>